module.exports = __webpack_public_path__ + "static/media/img2-3.fc0bdfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/ZN/img2-3.png
// module id = 1254
// module chunks = 3